import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api, apiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { toast.error("Password must be at least 8 characters."); return; }
    if (password !== confirm) { toast.error("Passwords don't match."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated — please sign in");
      navigate("/login", { replace: true });
    } catch (e) { toast.error(apiError(e)); }
    setLoading(false);
  };

  return (
    <div className="df-shell df-safe-top min-h-screen flex flex-col justify-center px-6">
      <div className="df-fade-in">
        <div className="flex items-center gap-3 mb-8">
          <img src="/molaroo-mark.png" alt="Molaroo" className="h-14 w-14 rounded-2xl object-contain bg-white shadow-sm" />
          <div>
            <div className="text-2xl font-heading font-bold tracking-tight text-slate-900 leading-none">Molaroo</div>
            <div className="text-sm text-slate-500 mt-1">Your income, organised.</div>
            <div className="text-xs text-slate-400 mt-0.5">by NavScora</div>
          </div>
        </div>

        {!token ? (
          <div data-testid="reset-no-token" className="df-card p-6 text-center">
            <h1 className="text-xl font-bold text-slate-900 mb-1">Invalid link</h1>
            <p className="text-slate-500 text-sm">This reset link is missing or invalid. Please request a new one.</p>
            <Link to="/forgot-password" className="inline-block mt-5 text-[#0D786A] font-semibold df-pressable">Request a new link</Link>
          </div>
        ) : (
          <>
            <h1 className="text-3xl font-bold tracking-tight text-slate-900 mb-1">Set a new password</h1>
            <p className="text-slate-500 mb-8">Choose a new password for your Molaroo account.</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="password" className="text-slate-700">New password</Label>
                <Input id="password" data-testid="reset-password" type="password" value={password}
                  onChange={(e) => setPassword(e.target.value)} placeholder="At least 8 characters"
                  className="mt-1.5 h-12 rounded-xl bg-white" required />
              </div>
              <div>
                <Label htmlFor="confirm" className="text-slate-700">Confirm password</Label>
                <Input id="confirm" data-testid="reset-confirm" type="password" value={confirm}
                  onChange={(e) => setConfirm(e.target.value)} className="mt-1.5 h-12 rounded-xl bg-white" required />
              </div>
              <Button type="submit" data-testid="reset-submit" disabled={loading}
                className="w-full h-12 rounded-xl bg-[#0D786A] hover:bg-[#0A6055] text-base font-semibold df-pressable">
                {loading ? "Updating…" : "Update password"}
              </Button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
